// Personel modulu icin Turkce etiketler. DB'de ASCII enum saklanir, burada Turkce'ye cevrilir.

export const STATUS_LABELS = {
    aktif: 'Aktif',
    ayrildi: 'Ayrıldı',
};

export const PAYMENT_TYPE_LABELS = {
    haftalik: 'Haftalık Ücret',
    avans: 'Avans',
    prim: 'Prim',
    mesai: 'Mesai',
    kesinti: 'Kesinti',
};

export const PAYMENT_TYPES = ['haftalik', 'avans', 'prim', 'mesai', 'kesinti'];

export const LEAVE_TYPE_LABELS = {
    yillik: 'Yıllık İzin',
    rapor: 'Raporlu (İstirahat)',
    ucretsiz: 'Ücretsiz İzin',
    mazeret: 'Mazeret İzni',
};

export const LEAVE_TYPES = ['yillik', 'rapor', 'ucretsiz', 'mazeret'];

export const DOCUMENT_LABEL_SUGGESTIONS = [
    'Kimlik',
    'Sözleşme',
    'Sağlık Raporu',
    'Diploma / Sertifika',
    'Fotoğraf',
    'Diğer',
];

export const CURRENCIES = ['TRY', 'USD', 'EUR', 'GBP'];

// Kesinti toplamda negatif sayilir.
export const isNegativePaymentType = (type) => type === 'kesinti';

export const formatAmount = (amount) =>
    new Intl.NumberFormat('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(amount || 0);
